
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";

import HeaderBlock from "@/components/HeaderBlock.vue";

import enUK from "@/locales/invoicing/en-UK.json";
import Tabs from "@/components/Tabs.vue";
import { isAdmin } from "@/helpers/router/queries";
import { useQuery } from "@vue/apollo-composable";
import { GET_USER } from "@/graphql/user/queries";

type MessageSchema = typeof enUK;

export default defineComponent({
  setup() {
    const { t } = useI18n<[MessageSchema], "en-UK">({
      useScope: "global",
      inheritLocale: true,
      messages: {
        "en-UK": enUK,
      },
    });

    const { result } = useQuery(GET_USER);
    const user = computed(() => result.value?.user);
    const isUserAdmin = computed(() => isAdmin(user.value?.accessRights));

    return {
      t,
      isUserAdmin,
    };
  },
  data() {
    return {
      enUK,
    };
  },
  components: {
    Tabs,
    HeaderBlock,
  },
});
